import { InputBase, InputAdornment, InputBaseProps } from "@mui/material";
import { SearchIcon } from "../../icons";
import { useState, useEffect } from "react";

export type SearchInputProps = {
  onChange: (value?: string) => void;
  value?: string;
} & Omit<InputBaseProps, "onChange" | "value">;

export function SearchInput({ sx, value, onChange = () => {}, ...others }: SearchInputProps) {
  const [query, setQuery] = useState<string | undefined>("");
  useEffect(() => {
    setQuery(value);
  }, [value]);
  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (query !== value) {
        onChange(query);
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [query]);

  return (
    <InputBase
      fullWidth
      sx={[
        {
          fontSize: "1rem",
          minHeight: "3.75rem",
          color: "text.primary",
          bgcolor: "primary.main",
          borderRadius: "1.125rem",
          "& .MuiInputAdornment-root": {
            marginLeft: "1.0625rem",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      value={query}
      onChange={(event) => setQuery(event.target.value)}
      placeholder="Find..."
      startAdornment={
        <InputAdornment
          position="start"
          style={{
            color: "rgba(255, 255, 255, 0.3)",
            width: "1.5rem",
            height: "1.5rem",
          }}
        >
          <SearchIcon />
        </InputAdornment>
      }
      {...others}
    />
  );
}

export default SearchInput;
